export type ProductEnvironment = 'dev' | 'production' | 'staging';

const urlsByEnvironment: Record<ProductEnvironment, Record<string, string>> = {
  dev: {
    Clepit: 'http://localhost:5022',
    Estimojo: 'http://localhost:5620',
    Gamblish: 'http://localhost:5221',
    Njangy: 'http://localhost:5121',
    Prodantix: 'http://localhost:4920',
    Workadabra: 'http://localhost:5321',
  },
  production: {
    Clepit: 'https://clepit.com',
    Estimojo: 'https://estimojo.bomdisoft.com',
    Gamblish: 'https://www.gamblish.org',
    Njangy: 'https://www.njangy.com',
    Prodantix: 'https://prodantix.com',
    Workadabra: 'https://www.workadabra.com',
  },
  staging: {
    Clepit: 'https://staging.clepit.com',
    Estimojo: 'https://staging.estimojo.bomdisoft.com',
    Gamblish: 'https://staging.gamblish.org',
    Njangy: 'https://staging.njangy.com',
    Prodantix: 'https://staging.prodantix.com',
    Workadabra: 'https://staging.workadabra.com',
  },
};

export const resolveProductEnvironment = (signals: { apexOrigin?: string; browserHostname?: string; nodeEnv?: string }): ProductEnvironment => {
  if (signals.nodeEnv === 'development') {
    return 'dev';
  }
  if (signals.browserHostname?.startsWith('staging.') || signals.apexOrigin?.startsWith('https://staging.')) {
    return 'staging';
  }
  return 'production';
};

const environment = resolveProductEnvironment({
  apexOrigin: process.env.NEXT_PUBLIC_BOMDISOFT_AUTH_APEX_ORIGIN,
  browserHostname: typeof window === 'undefined' ? undefined : window.location.hostname,
  nodeEnv: process.env.NODE_ENV,
});

export const products = [
  { height: 36, logo: '/images/products/prodantix.png', name: 'Prodantix', tag: 'Analytics', url: urlsByEnvironment[environment].Prodantix, width: 36 },
  { height: 36, logo: '/images/products/clepit.png', name: 'Clepit', tag: 'Knowledge Base', url: urlsByEnvironment[environment].Clepit, width: 36 },
  { height: 36, logo: '/images/products/njangy.png', name: 'Njangy', tag: 'Finance', url: urlsByEnvironment[environment].Njangy, width: 36 },
  { height: 36, logo: '/images/products/gamblish.png', name: 'Gamblish', tag: 'Gaming', url: urlsByEnvironment[environment].Gamblish, width: 36 },
  { height: 26, logo: '/images/products/workadabra.png', name: 'Workadabra', tag: 'Marketplace', url: urlsByEnvironment[environment].Workadabra, width: 36 },
  { height: 36, logo: '/images/products/estimojo.png', name: 'Estimojo', tag: 'Agile Estimation', url: urlsByEnvironment[environment].Estimojo, width: 36 },
];
